"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_consts_1 = require("../config.consts");
const CLConnectMock_1 = __importDefault(require("../../ApiLayers/CLConnect/CLConnectMock"));
const factory = () => new CLConnectMock_1.default();
exports.default = {
    container: {
        entries: {
            [config_consts_1.AUTH_API]: factory,
            [config_consts_1.DAY_TYPE_API]: factory,
            [config_consts_1.CUSTOMER_LIST]: factory,
            [config_consts_1.COACH_CAPACITY]: factory,
            [config_consts_1.COACH_RATING_LIST]: factory,
            [config_consts_1.COACH_USER]: factory,
            [config_consts_1.PBP_CHAT_API]: factory,
            [config_consts_1.PMP_CHAT_API]: factory,
            [config_consts_1.CUSTOMER_NOTIFICATIONS_API]: factory,
            [config_consts_1.NUTRITION_CALORIE_BUDGET]: factory,
            [config_consts_1.NUTRITION_FOOD_PREFERENCE]: factory,
            [config_consts_1.TRAINING_API]: factory,
            [config_consts_1.MEASUREMENTS_API]: factory,
            [config_consts_1.NUTRITION_API]: factory,
            [config_consts_1.BEHAVIOUR_API]: factory,
            [config_consts_1.FETCH]: factory,
            [config_consts_1.RECOVERY_API]: factory,
            [config_consts_1.JOURNAL_API]: factory,
            [config_consts_1.CUSTOMER_NOTES]: factory,
            [config_consts_1.HISTORY_API]: factory,
            [config_consts_1.SPORT_ACTIVITY_API]: factory,
            [config_consts_1.TRAINEE_LIST_API]: factory,
            [config_consts_1.COACH_MONTHLY_MEMBERS_OVERVIEW]: factory,
        },
        recipes: {},
    },
};
//# sourceMappingURL=clconnect.js.map